export default class PlatformSlider {

    constructor(element) {
        this.element = element;
        this.slides = Array.from(this.element.querySelectorAll('.c-platform-slider__slide'));
        this.nextButton = this.element.querySelector('.c-platform-slider__arrow--next');
        this.prevButton = this.element.querySelector('.c-platform-slider__arrow--prev');
        this.status = this.element.querySelector('.c-platform-slider__status');
        this.pagination = this.element.querySelector('.c-platform-slider__pagination');

        this.currentIndex = 0;
        this.totalSlides = this.slides.length;

        this.initPagination();

        for (const slide of this.slides) {
            slide.addEventListener('click', () => this.next());
        }

        this.nextButton.addEventListener('click', () => this.next());
        this.prevButton.addEventListener('click', () => this.prev());
        this.goToSlide(this.currentIndex);
    }

    goToSlide(index) {
        this.currentIndex = index % this.totalSlides;

        if (this.currentIndex < 0) {
            this.currentIndex += this.totalSlides;
        }

        let nextIndex = (this.currentIndex + 1) % this.totalSlides;
        let prevIndex = (this.currentIndex - 1) % this.totalSlides;

        if (prevIndex < 0) {
            prevIndex += this.totalSlides;
        }

        const current = this.slides[this.currentIndex];
        const next = this.slides[nextIndex];
        const prev = this.slides[prevIndex];

        for (const slide of this.slides) {
            slide.classList.remove("c-platform-slider__current");
            slide.classList.remove("c-platform-slider__next");
            slide.classList.remove("c-platform-slider__prev");
        }

        current.classList.add("c-platform-slider__current");
        next.classList.add("c-platform-slider__next");
        prev.classList.add("c-platform-slider__prev");

        for (const button of this.paginationButtons) {
            button.classList.remove('c-platform-slider__pagination-button--active');
        }

        this.paginationButtons[this.currentIndex].classList.add(
            'c-platform-slider__pagination-button--active'
        );

        this.status.innerText = `${this.currentIndex + 1} / ${this.totalSlides}`;
    }

    next() {
        this.goToSlide(this.currentIndex + 1);
    }

    prev() {
        this.goToSlide(this.currentIndex - 1);
    }

    initPagination() {
        this.paginationButtons = [];

        for (let i = 0; i < this.totalSlides; i++) {
            const button = document.createElement('div');
            button.classList.add('c-platform-slider__pagination-button');
            button.innerText = `Go to slide ${i + 1}`;
            button.addEventListener('click', () => this.goToSlide(i));
            this.pagination.appendChild(button);
            this.paginationButtons.push(button);
        }
    }

}
